import { r as registerInstance, h } from './index-5faac9d7.js';
import { aa as pesIconSizes } from './currency-49e0d692.js';

const slidingNotifierCss = ".sliding-notifier{display:block}.sliding-notifier__label{display:flex;justify-content:center;align-items:center;color:#000000;font-size:0.8125rem;line-height:1.125rem;height:1.125rem;letter-spacing:-0.005rem;margin:10px auto 0;overflow:hidden}:host(:not([dir=\"rtl\"])) .sliding-notifier__icon{padding-right:2px}:host([dir=\"rtl\"]) .sliding-notifier__icon{padding-left:2px}";

const SlidingNotifier = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.notificationText = undefined;
    this.isActive = undefined;
    this.icon = 'notification_ok';
  }
  render() {
    return (h("pes-slide-down-container", { class: "sliding-notifier", active: this.isActive }, h("div", { class: "sliding-notifier__label" }, h("pes-icon", { class: "sliding-notifier__icon", size: pesIconSizes.MEDIUM }, this.icon), h("span", { class: "sliding-notifier__text" }, this.notificationText))));
  }
};
SlidingNotifier.style = slidingNotifierCss;

export { SlidingNotifier as pes_sliding_notifier };
